<div class="header-toolbar">
  <mat-toolbar>
    <div class="header-wrraper">
      <button class="sidenav-btn shadow-none" (click)="toggleCollapse()">
        <svg width="30" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <div class="me-2 ms-auto">
        <button mat-button [matMenuTriggerFor]="menu" class="user p-0">
          <div class="d-flex align-items-center">
            <img
              src="assets/images/profile.jpg"
              alt="profile"
              class="user-image me-1 p-2" />
            <span>{{ userInfo?.userName }}</span>
            <mat-icon class="user-image-icon ml-1">
              keyboard_arrow_down
            </mat-icon>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item routerLink="profile" *appHasAccess="'/profile'">
            <mat-icon>account_circle</mat-icon>
            <span>My Profile</span>
          </button>
          <button mat-menu-item (click)="doLogOut()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>
</div>

<!-- Mobile navigation drawer (shown on small screens via the hamburger).
     Kept outside the backdrop-filtered toolbar so position:fixed is relative
     to the viewport. A scrim dims the content and closes the drawer on tap. -->
<div
  class="sidenav-backdrop"
  [class.open]="collapsed"
  [attr.aria-hidden]="true"
  (click)="toggleCollapse()"></div>
<div class="sidenav sidenav-md" [class.open]="collapsed">
  <div class="logo-container">
    <button class="close-btn d-flex shadow-none" (click)="toggleCollapse()">
      <span class="material-icons">keyboard_backspace</span>
    </button>
  </div>
  <hr class="mb-0 pb-0 text-white" />
  <div class="scrollwrap scrollwrap_delayed">
    <ul class="sidenav-nav">
      <li class="sidenav-nav-item" *ngFor="let data of navData">
        <ng-container *ngIf="data.hasAccess">
          <a
            *ngIf="data.items && data.items.length > 0"
            class="sidenav-nav-link"
            [attr.aria-hidden]="true"
            (click)="handleClick(data)"
            [ngClass]="getActiveClass(data)">
            <img [src]="data.icon" alt="nav-icon" />
            <span class="sidenav-link-text">{{ data.label }}</span>
            <svg
              *ngIf="data.items"
              class="menu-collapse-icon"
              [ngClass]="{ 'angle-down': data.expanded }"
              role="img"
              width="1em"
              height="1em"
              viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="#f3f3f3"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="m9 6l6 6l-6 6"></path>
            </svg>
          </a>
          <a
            class="sidenav-nav-link"
            *ngIf="!data.items || (data.items && data.items.length === 0)"
            [routerLink]="[data.routeLink]"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="toggleCollapse()">
            <img [src]="data.icon" alt="nav-icon" />
            <span class="sidenav-link-text">{{ data.label }}</span>
          </a>
          <div
            [attr.aria-hidden]="true"
            (click)="toggleCollapse()"
            *ngIf="data.items && data.items.length > 0">
            <app-sublevel-menu
              [data]="data"
              [collapsed]="collapsed"
              [multiple]="multiple"
              [expanded]="data.expanded">
            </app-sublevel-menu>
          </div>
        </ng-container>
      </li>
    </ul>
  </div>
</div>
